module.exports = __webpack_public_path__ + "static/img/login-v2.374a04af.svg";